import {Text} from "@pg-design/text-module";

import * as styles from "./FooterContactBox.module.css";

interface IProps {
    lines: string[];
    className?: string;
}

export const FooterContactBox = (props: IProps) => {
    return (
        <div className={props.className}>
            <Text variant="headline_6" as="p" color="var(--colors-white)" mb={3}>
                Kontakt
            </Text>

            <Text variant="info_txt_1" as="div" className={styles.lines}>
                {props.lines.map((line) => (
                    <div key={line}>{line}</div>
                ))}
            </Text>
        </div>
    );
};
import {Text} from "@pg-design/text-module";

import * as styles from "./FooterContactBox.module.css";

interface IProps {
    lines: string[];
    className?: string;
}

export const FooterContactBox = (props: IProps) => {
    return (
        <div className={props.className}>
            <Text variant="headline_6" as="p" color="var(--colors-white)" mb={3}>
                Kontakt
            </Text>

            <Text variant="info_txt_1" as="div" className={styles.lines}>
                {props.lines.map((line) => (
                    <div key={line}>{line}</div>
                ))}
            </Text>
        </div>
    );
};
